/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { TFunction, useTranslation } from 'react-i18next';
import { Row, Col } from 'react-bootstrap';
import { connect, useSelector } from 'react-redux';
import Loader from '../../../Components/Utility/Loader/Loader';
import {
  deleteUser,
  deleteMultiUser,
  getSupplierUser,
  updateUserStatus,
  fetchRightsAssignmentAction,
  fetchAllBrandAction,
  fetchCategoryAction,
  fetchCategory2Action,
  setUserPassword,
  clearUserReducer,
  addSupplierUser,
  editSupplierUser,
  addUserRightsAssignmentAction,
} from '../store/Supplier.action';
import UserTable from './UserTable';
import type { SupplierUserRow, UserDraftRow, UserStatusChange } from './UserTable';
import GlobalAssignmentModal from './GlobalAssignmentModal';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import { recoverUsersMFA as _recoverUsersMFA } from '../../Auth/store/Auth.action';
import _SetNewPassword from '../../UserSetting/UsersLibrary/SetNewPasswordModal';
import { getMultiSubBrandDetails as _getMultiSubBrandDetails } from '../../SystemMasters/Store/SystemMasters.action';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import SupplierTabNav from '../SupplierTabNav';
import { Floaty, FloatyButton, FloatyGroup } from '../../../Components/Floaty';
import { AddIcon, DeleteIcon, SettingsIcon } from '../../../bombiix-icon';
import { NewSearch } from '../../../Components/PIM/common/NewSearch';
import { NewBackButton } from '../../../Components/PIM/common/NewBackButton';
import type { NewSelectMultiSelectOption } from '../../../Components/PIM/common/NewSelectMultiSelect/NewSelectMultiSelect';
import { AppDispatch, useAppDispatch } from '../../../hooks/useAppDispatch';
import {
  pruneSubBrandsToBrands,
  type AssignmentDraft,
  type AssignmentField,
  type AssignmentsByUser,
  type AssignmentValue,
  type ResolvedAssignment,
  type SubBrandOption,
} from './user-assignment.types';
import { BombiixModal } from '../../../Components/BombiixModal';
import { mergeTouchedGrants, rightsToAssignmentDraft } from './user-assignment.types';

/**
 * A function type described by its argument tuple and return type.
 */
type Fn<TArgs extends unknown[], TResult> = (...args: TArgs) => TResult;

type Thunk<TResult> = Fn<[dispatch: AppDispatch], Promise<TResult>>;
type CheckActionPermissionFn = Fn<[rights: unknown, section: string, module?: string, action?: string], boolean>;

/**
 * A user's rights assignment as the rights endpoint returns it: `true` for all
 * access, otherwise an array of granted ids.
 */
interface UserRights {
  brands?: unknown;
  subBrands?: unknown;
  typeOneCategories?: unknown;
  typeTwoCategories?: unknown;
  productTypes?: unknown;
}

interface RightsAssignmentPayload {
  userId: string;
  loggedInUserId: string | undefined;
  brands: true | string;
  subBrands: true | string;
  typeOneCategories: true | string;
  typeTwoCategories: true | string;
  productTypes: true | string;
  section: string;
  action: string;
}

interface SupplierUserRecord {
  firstName: unknown;
  lastName: unknown;
  title: unknown;
  email: unknown;
  phoneNo: unknown;
  supplierId: string;
  accountVerified: boolean;
  section: string;
  action: string;
}

interface SavedUserResponse {
  data?: { userId?: string; _id?: string };
}

interface SupplierUserQuery {
  supplierId: string;
  searchText?: string;
  sortOrder?: string;
  sortPropertyName?: string;
}

interface OwnProps {
  match: { params: { supplierId: string } };
}

interface StateProps {
  usersList: SupplierUserRow[];
  userInfo: { userId?: string };
  brands: NewSelectMultiSelectOption[] | undefined;
  categoryType1: NewSelectMultiSelectOption[] | undefined;
  categoryType2: NewSelectMultiSelectOption[] | undefined;
}

interface DispatchProps {
  deleteUser: Fn<[payload: { supplierId: string; section: string; action: string }, userId: string | null | undefined, transactionMsg: TFunction<'common'>], Promise<unknown>>;
  deleteMultiUser: Fn<[payload: Record<string, unknown>, transactionMsg: TFunction<'common'>], Promise<unknown>>;
  getSupplierUser: Fn<[params: SupplierUserQuery], Promise<unknown>>;
  updateUserStatus: Fn<[payload: Record<string, unknown>, userId: string | undefined], Promise<unknown>>;
  fetchRightsAssignmentAction: Fn<[params: { userId: string }], Promise<UserRights | null | undefined>>;
  fetchAllBrandAction: Fn<[params: Record<string, unknown>], Promise<unknown>>;
  fetchCategoryAction: Fn<[params: Record<string, unknown>], Promise<unknown>>;
  fetchCategory2Action: Fn<[params: Record<string, unknown>], Promise<unknown>>;
  setUserPassword: Fn<[detail: Record<string, unknown>, transactionMsg: TFunction<'common'>], Promise<unknown>>;
  clearUserReducer: () => void;
  addSupplierUser: Fn<[record: SupplierUserRecord, transactionMsg: TFunction<'common'>], Promise<SavedUserResponse | undefined>>;
  editSupplierUser: Fn<[record: SupplierUserRecord, userId: string, transactionMsg: TFunction<'common'>], Promise<SavedUserResponse | undefined>>;
  addUserRightsAssignmentAction: Fn<[payload: RightsAssignmentPayload, transactionMsg: TFunction<'common'>], Promise<unknown>>;
}

interface SuppliersUsersStoreState {
  Users: { logInRights?: unknown };
  SystemMastersDetails?: { multiSubBrandList?: Array<{ _id?: string; name?: string; isActive?: boolean; brandId?: string }> };
  SuppliersDetails: StateProps;
  UserDetails: { userInfo: { userId?: string } };
}

type SuppliersUsersProps = OwnProps & StateProps & DispatchProps;

const SetNewPassword = _SetNewPassword as unknown as React.FC<{
  title: string;
  user: SupplierUserRow;
  show: boolean;
  toggle: Fn<[user?: SupplierUserRow], void>;
}>;
const recoverUsersMFA = _recoverUsersMFA as unknown as Fn<[data: { email: string | undefined; userId: string | undefined }, trans: TFunction<'common'>], Thunk<unknown>>;
const getMultiSubBrandDetails = _getMultiSubBrandDetails as unknown as Fn<[params: { loggedInUserId: string | undefined; isActive: boolean; brandId?: Array<string | number> }], Thunk<unknown>>;

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/**
 * Encodes one grant for the rights endpoint: ids travel as a JSON string and
 * `true` is the all-access sentinel.
 * @param {AssignmentValue | undefined} value - The grant.
 * @returns {true | string} The encoded grant.
 */
const encodeGrant = (value: AssignmentValue | undefined): true | string => (value === true ? true : JSON.stringify((value ?? []).map(String)));

/**
 * Re-encodes a user's existing product-type grant so it is written back unchanged.
 * @param {UserRights} existing - The user's current rights.
 * @returns {true | string} The encoded grant.
 */
const encodeExistingProductTypes = (existing: UserRights): true | string =>
  existing?.productTypes === true ? true : JSON.stringify(Array.isArray(existing?.productTypes) ? existing.productTypes : []);

/**
 * Supplier users tab: the users grid with inline add/edit, per-user rights, the
 * bulk global assignment and the set-password / reset-2FA actions.
 *
 * The Brand / Sub Brand / Category columns come from each user's rights
 * assignment, which the users-list endpoint does not return — it stops at name,
 * title, email, phone and accountVerified. The masters are loaded once so ids can
 * be resolved to labels, and the assignments are fetched per user in parallel.
 * Sub-brands live in the System Masters slice, not the supplier one, and nothing
 * else on this screen loads them, so they are fetched here too.
 *
 * Each user's grants are fetched individually, and only for ids never fetched
 * before: `allUsers` gets a fresh identity on every store write, and refetching
 * the whole set each time turned one row save into N extra round trips.
 * `fetchedRightsIds` is a ref rather than state so consulting it does not itself
 * retrigger the fetch.
 * @param {object} props - Component props.
 * @returns {React.ReactElement} The users tab.
 */
function SuppliersUsers({
  usersList,
  deleteUser: deleteUserProp,
  deleteMultiUser: deleteMultiUserProp,
  match,
  getSupplierUser: getSupplierUserProp,
  updateUserStatus: updateUserStatusProp,
  fetchRightsAssignmentAction: fetchRightsAssignmentActionProp,
  userInfo,
  fetchAllBrandAction: fetchAllBrandActionProp,
  fetchCategoryAction: fetchCategoryActionProp,
  fetchCategory2Action: fetchCategory2ActionProp,
  setUserPassword: setUserPasswordProp,
  clearUserReducer: clearUserReducerProp,
  addSupplierUser: addSupplierUserProp,
  editSupplierUser: editSupplierUserProp,
  addUserRightsAssignmentAction: addUserRightsAssignmentActionProp,
  brands,
  categoryType1,
  categoryType2,
}: SuppliersUsersProps) {
  const loggedInUserId = userInfo.userId;
  const [selectedIdArray, setSelectedIdArray] = useState<Array<string | undefined>>([]);
  const [allUsers, setAllUsers] = useState<SupplierUserRow[]>([]);
  const [rightsByUser, setRightsByUser] = useState<Record<string, UserRights>>({});
  const [draftRow, setDraftRow] = useState<UserDraftRow | null>(null);
  const [showChangePassModel, setShowChangePassModel] = useState(false);
  const [passwordUser, setPasswordUser] = useState<SupplierUserRow>({});
  const [editingUserId, setEditingUserId] = useState<string | null>(null);
  const [isGlobalAssignment, setIsGlobalAssignment] = useState(false);
  const [globalDraft, setGlobalDraft] = useState<AssignmentDraft | null>(null);
  const [globalTouchedFields, setGlobalTouchedFields] = useState<AssignmentField[]>([]);
  const [isSelectAll, setSelectAll] = useState(false);
  const [index, setIndex] = useState<string | null | undefined>(null);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [, setaddEditOpen] = useState({
    isOpen: false,
    isEdit: false,
  });
  const [, seteditData] = useState<{ data: SupplierUserRow | null; index: string | number }>({ data: null, index: -1 });
  const [isMultiDelete, setisMultiDelete] = useState(false);
  const [confirmLoader, setConfirmLoader] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [count, setCount] = useState(0);
  const [sortTable, setSortTable] = useState<SupplierUserQuery>({
    sortOrder: '',
    sortPropertyName: '',
    supplierId: '',
  });
  const ProductTestingData = useSelector((redState: SuppliersUsersStoreState) => redState);
  const { Users } = ProductTestingData;
  const dispatch = useAppDispatch();
  const { multiSubBrandList } = useSelector((redState: SuppliersUsersStoreState) => redState?.SystemMastersDetails || {});
  const { logInRights } = Users;
  const [userRights, setUserRights] = useState<unknown>({});

  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  });
  const CheckActionPermission = useComponent().CheckActionPermission as unknown as CheckActionPermissionFn;

  const CostingAddEditAccess = CheckActionPermission(userRights, 'supplierOverview', 'all', 'addEdit');
  const CostingDeleteAccess = CheckActionPermission(userRights, 'supplierOverview', 'all', 'delete');

  const { t } = useTranslation('common');
  const history = useHistory();
  const [state, setState] = useState({
    loading: true,
    searchText: '',
    searchLoaded: false,
    supplierId: '',
  });

  const { supplierId } = match.params;

  const closeConfirmationsPopup = () => {
    setShowConfirmationPopup(false);
    setIndex(null);
  };

  const deleteSupplierConfirmed = async () => {
    setConfirmLoader(true);
    const supplierID = {
      supplierId,
      section: 'supplierOverview',
      action: 'delete',
    };
    if (isMultiDelete) {
      const multiDelPayload = {
        multipleDelete: true,
        supplierId,
        userIds: selectedIdArray,
        section: 'supplierOverview',
        action: 'delete',
      };

      await deleteMultiUserProp(multiDelPayload, t);
    } else {
      await deleteUserProp(supplierID, index, t);
    }
    setConfirmLoader(false);
    setShowConfirmationPopup(!showConfirmationPopup);
    setSelectAll(false);
    setSelectedIdArray([]);
  };

  const onDelete = (i: string | undefined) => {
    setisMultiDelete(false);
    setShowConfirmationPopup(!showConfirmationPopup);
    setIndex(i);
  };

  useEffect(() => {
    if (allUsers.length === selectedIdArray.length && allUsers.length > 0) {
      setSelectAll(true);
    }
  }, [selectedIdArray]);

  useEffect(() => {
    setIsLoader(true);
    setAllUsers(usersList);
    setIsLoader(false);
  }, [usersList]);

  useEffect(() => {
    const loadAssignmentMasters = async () => {
      await Promise.all([
        fetchAllBrandActionProp({ accessedFrom: 'masters', loggedInUserId }),
        fetchCategoryActionProp({ accessedFrom: 'masters', loggedInUserId, categoryType: 1 }),
        fetchCategory2ActionProp({ accessedFrom: 'masters', loggedInUserId, categoryType: 2 }),
      ]);
    };
    loadAssignmentMasters();
  }, [loggedInUserId]);

  const fetchedRightsIds = useRef(new Set<string>());

  useEffect(() => {
    let cancelled = false;
    const ids = (allUsers ?? []).map((user) => user?._id).filter((id): id is string => Boolean(id));
    if (ids.length === 0) {
      fetchedRightsIds.current = new Set();
      setRightsByUser({});
      return undefined;
    }
    const missing = ids.filter((id) => !fetchedRightsIds.current.has(id));
    if (missing.length === 0) return undefined;
    const loadRights = async () => {
      const entries = await Promise.all(
        missing.map(async (id): Promise<[string, UserRights]> => {
          const rights = await fetchRightsAssignmentActionProp({ userId: id });
          return [id, rights ?? {}];
        }),
      );
      if (cancelled) return;
      missing.forEach((id) => fetchedRightsIds.current.add(id));
      setRightsByUser((previous) => ({ ...(previous ?? {}), ...Object.fromEntries(entries) }));
    };
    loadRights();
    return () => {
      cancelled = true;
    };
  }, [allUsers]);

  /**
   * Mirrors a just-saved grant into local state so the grid reflects it without
   * refetching. The shape matches what the rights endpoint returns.
   * @param {string} userId - User whose grants were written.
   * @param {object} grants - Draft values: brand, subBrand, category1, category2.
   * @returns {void}
   */
  const applySavedRights = (userId: string, grants: AssignmentDraft) => {
    const toStored = (value: AssignmentValue | undefined) => (value === true ? true : (value ?? []).map(String));
    fetchedRightsIds.current.add(userId);
    setRightsByUser((previous) => ({
      ...(previous ?? {}),
      [userId]: {
        ...(previous?.[userId] ?? {}),
        brands: toStored(grants.brand),
        subBrands: toStored(grants.subBrand),
        typeOneCategories: toStored(grants.category1),
        typeTwoCategories: toStored(grants.category2),
      },
    }));
  };

  useEffect(() => {
    setIsLoader(true);
    const supplierID = {
      supplierId,
    };

    getSupplierUserProp(supplierID);
    setIsLoader(false);
  }, [showConfirmationPopup]);

  useEffect(() => {
    return () => {
      setCount(1);
      clearUserReducerProp();
    };
  }, []);

  /**
   * Resolves one rights-assignment field onto chip labels.
   *
   * `true` is the "all access" sentinel the assignment modal writes when every
   * option is granted — the design shows that as a single "Full Access" chip
   * rather than listing every brand, so it is reported separately from the
   * resolved labels.
   * @param {*} assigned - `true` for all access, or an array of granted ids.
   * @param {Array<object>} options - Master list of `{ label, value }`.
   * @returns {{isAll: boolean, labels: string[]}} The cell's display state.
   */
  const resolveAssignment = (assigned: unknown, options: NewSelectMultiSelectOption[] | undefined): ResolvedAssignment => {
    if (assigned === true) return { isAll: true, labels: [] };
    if (!Array.isArray(assigned) || assigned.length === 0) return { isAll: false, labels: [] };
    const granted = new Set(assigned.map(String));
    return {
      isAll: false,
      labels: (options ?? [])
        .filter((option) => granted.has(String(option?.value)))
        .map((option) => option?.label)
        .filter(Boolean),
    };
  };

  const subBrandOptions = useMemo(
    (): SubBrandOption[] =>
      (multiSubBrandList ?? [])
        .filter((entry) => entry?.isActive)
        .map((entry) => ({ label: entry?.name ?? '', value: entry?._id ?? '', ...(entry?.brandId ? { brandId: String(entry.brandId) } : {}) })),
    [multiSubBrandList],
  );

  /**
   * Per-row display state for the four assignment columns, keyed by user id, so
   * the grid's cell renderers stay pure lookups.
   */
  const assignmentsByUser = useMemo(() => {
    const out: AssignmentsByUser = {};
    Object.entries(rightsByUser ?? {}).forEach(([userId, rights]) => {
      out[userId] = {
        brand: resolveAssignment(rights?.brands, brands),
        subBrand: resolveAssignment(rights?.subBrands, subBrandOptions),
        category1: resolveAssignment(rights?.typeOneCategories, categoryType1),
        category2: resolveAssignment(rights?.typeTwoCategories, categoryType2),
      };
    });
    return out;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rightsByUser, brands, categoryType1, categoryType2, subBrandOptions]);

  const onSelectCheckBox = async (e: React.ChangeEvent<HTMLInputElement>, id: string | undefined) => {
    let selectedItems = [...selectedIdArray];

    if (e.target.checked) {
      setSelectedIdArray([...selectedItems, id]);
    } else {
      setSelectAll(false);
      selectedItems = selectedItems.filter((item) => item !== id);
      setSelectedIdArray([...selectedItems]);
    }
  };

  const handleSelectAll = () => {
    if (isSelectAll) {
      setSelectedIdArray([]);
    } else {
      const selectedItems = [...selectedIdArray];
      allUsers.forEach((item) => {
        const findItems = selectedItems?.filter((val) => val === item._id);
        if (findItems?.length === 0) {
          selectedItems?.push(item?._id);
        }
      });
      setSelectedIdArray(selectedItems);
    }
    setSelectAll(!isSelectAll);
  };

  const EMPTY_DRAFT: UserDraftRow = { firstName: '', lastName: '', title: '', email: '', phoneNo: '', brand: [], subBrand: [], category1: [], category2: [] };

  /**
   * Seeds an inline draft row for a new user. The design puts creation in the
   * table itself (Figma node 12385:163422) rather than a modal, so the entry row
   * is the same shape as an edit row — the only difference is that it has no id
   * yet and pins to the top of the grid.
   * @returns {void}
   */
  const startAddRow = () => {
    setEditingUserId(null);
    setDraftRow({ ...EMPTY_DRAFT });
  };

  /**
   * Puts an existing row into edit mode, seeding the draft from the record and
   * its resolved rights assignment.
   * @param {string} userId - The user to edit.
   * @returns {void}
   */
  const startEditRow = (userId: string | undefined) => {
    const user = (allUsers ?? []).find((entry) => entry?._id === userId);
    if (!user || !userId) return;
    const rights = rightsByUser?.[userId] ?? {};
    setDraftRow({
      firstName: user.firstName ?? '',
      lastName: user.lastName ?? '',
      title: user.title ?? '',
      email: user.email ?? '',
      phoneNo: user.phoneNo ?? '',
      ...rightsToAssignmentDraft(rights),
    });
    setEditingUserId(userId);
  };

  /**
   * Opens the global assignment editor: the same four grants, applied to every
   * ticked user in one go rather than row by row. With a single user ticked the
   * editor starts from that user's saved grants, so it never opens blank over
   * grants the user already holds.
   * @returns {void}
   */
  const openGlobalAssignment = () => {
    const singleUserId = selectedIdArray.length === 1 ? selectedIdArray[0] : undefined;
    const singleUserRights = singleUserId ? rightsByUser?.[singleUserId] : undefined;
    setGlobalDraft(singleUserRights ? rightsToAssignmentDraft(singleUserRights) : { brand: [], subBrand: [], category1: [], category2: [] });
    setGlobalTouchedFields([]);
    setIsGlobalAssignment(true);
  };

  /**
   * Updates one grant in the global draft and marks it as changed, so Apply only
   * rewrites the grants the user actually edited.
   * @param {string} field - Draft field name.
   * @param {*} value - New value.
   * @returns {void}
   */
  const changeGlobalField = (field: AssignmentField, value: AssignmentValue) => {
    setGlobalDraft((previous) => ({ ...(previous ?? {}), [field]: value }));
    setGlobalTouchedFields((previous) => (previous.includes(field) ? previous : [...previous, field]));
  };

  /**
   * Writes the bulk assignment to the ticked users only — this is a bulk edit of a
   * selection, not of the page. Each user's own record is left alone — only the
   * rights are rewritten — so this cannot disturb names or emails. Only the grants
   * edited in the modal replace the user's saved ones; every other grant, and the
   * product-type grant the modal does not offer, is re-sent unchanged from
   * `rightsByUser`, because the rights endpoint replaces the whole assignment.
   * @returns {void}
   */
  const saveGlobalAssignment = async () => {
    if (!globalDraft || selectedIdArray.length === 0 || globalTouchedFields.length === 0) return;
    setIsLoader(true);
    const updates = selectedIdArray
      .filter((id): id is string => Boolean(id))
      .map((id) => {
        const existing = rightsByUser?.[id] ?? {};
        return { id, existing, grants: mergeTouchedGrants(rightsToAssignmentDraft(existing), globalDraft, globalTouchedFields) };
      });
    await Promise.all(
      updates.map(({ id, existing, grants }) =>
        addUserRightsAssignmentActionProp(
          {
            userId: id,
            loggedInUserId,
            brands: encodeGrant(grants.brand),
            subBrands: encodeGrant(grants.subBrand),
            typeOneCategories: encodeGrant(grants.category1),
            typeTwoCategories: encodeGrant(grants.category2),
            productTypes: encodeExistingProductTypes(existing),
            section: 'supplierOverview',
            action: 'addEdit',
          },
          t,
        ),
      ),
    );
    updates.forEach(({ id, grants }) => applySavedRights(id, grants));
    setIsGlobalAssignment(false);
    setGlobalDraft(null);
    setGlobalTouchedFields([]);
    setIsLoader(false);
  };

  /** Discards the draft without writing anything. */
  const cancelRowEdit = () => {
    setDraftRow(null);
    setEditingUserId(null);
  };

  /**
   * Updates one field of the draft row.
   * @param {string} field - Draft field name.
   * @param {*} value - New value.
   * @returns {void}
   */
  const changeDraftField = (field: string, value: string | AssignmentValue) => {
    setDraftRow((previous) => {
      const next = { ...(previous ?? EMPTY_DRAFT), [field]: value };
      if (field !== 'brand' || typeof value === 'string') return next;
      const prunedSubBrand = pruneSubBrandsToBrands(next.subBrand, value, subBrandOptions);
      return prunedSubBrand === undefined ? next : { ...next, subBrand: prunedSubBrand };
    });
  };

  /**
   * Writes the draft row. The user record and the rights assignment are two
   * separate endpoints, so both are issued: the record first, because the
   * assignment needs an id, then the rights for that id.
   *
   * `addSupplierUser` returns the new id as `data.userId`; only `editSupplierUser`
   * echoes `_id`, so both are read. The rights use the same contract the
   * assignment modal used — ids as a JSON string, `true` for all access — and
   * `productTypes`, which has no column in the table design, is passed straight
   * back rather than cleared.
   * @returns {void}
   */
  const saveRowEdit = async () => {
    if (!draftRow) return;
    const required = ['firstName', 'lastName', 'title', 'email'];
    if (required.some((field) => !String(draftRow[field] ?? '').trim())) {
      toasterMsg(t('ADD_EDIT_COMPONENET.NAME_REQUIRED'), 'danger');
      return;
    }
    if (!EMAIL_PATTERN.test(String(draftRow.email).trim())) {
      toasterMsg(t('ADD_EDIT_COMPONENET.INVALID_EMAIL_MESSAGE'), 'danger');
      return;
    }
    setIsLoader(true);
    const record = {
      firstName: draftRow.firstName,
      lastName: draftRow.lastName,
      title: draftRow.title,
      email: draftRow.email,
      phoneNo: draftRow.phoneNo,
      supplierId,
      accountVerified: true,
      section: 'supplierOverview',
      action: 'addEdit',
    };
    const saved = editingUserId ? await editSupplierUserProp(record, editingUserId, t) : await addSupplierUserProp(record, t);
    const savedId = editingUserId || saved?.data?.userId || saved?.data?._id;
    if (savedId) {
      const existing = rightsByUser?.[savedId] ?? {};
      await addUserRightsAssignmentActionProp(
        {
          userId: savedId,
          loggedInUserId,
          brands: encodeGrant(draftRow.brand),
          subBrands: encodeGrant(draftRow.subBrand),
          typeOneCategories: encodeGrant(draftRow.category1),
          typeTwoCategories: encodeGrant(draftRow.category2),
          productTypes: encodeExistingProductTypes(existing),
          section: 'supplierOverview',
          action: 'addEdit',
        },
        t,
      );
      applySavedRights(savedId, draftRow);
    }
    cancelRowEdit();
    setIsLoader(false);
  };

  const handleAddEditOpenClose = async (e: { preventDefault: () => void } | null, id: string | undefined) => {
    if (e) e.preventDefault();

    setaddEditOpen((prev) => ({
      ...prev,
      isOpen: !prev.isOpen,
      isEdit: !!(id !== null && id !== undefined),
    }));

    let obj: { data: SupplierUserRow | null; index: string | number } = { data: null, index: -1 };
    if (id !== null && id !== undefined) {
      const data = usersList.filter((user) => user._id === id);
      if (data?.[0]) {
        obj = { data: data[0], index: id };
      }
    }
    await seteditData(obj);
    if (id === 'addEditSuccess') {
      const supplierID = {
        supplierId,
      };

      getSupplierUserProp(supplierID);
    }
  };

  const handleUserStatusUpdate = async (_e: React.ChangeEvent<HTMLInputElement>, data: UserStatusChange) => {
    const idStatus = {
      supplierId,
      stateGoesTo: data.user_status ? 'Deactivate' : 'Activate',
      section: 'supplierOverview',
      action: 'addEdit',
    };
    const isStatus = await updateUserStatusProp(idStatus, data.user_id);
    if (isStatus) {
      await getSupplierUserProp({ supplierId });
    }
  };

  const onSetPassword = (id: string | undefined, email: string | undefined) => {
    const userDetail = {
      checkFor: 'SupplierUser',
      email,
      userId: id,
    };
    setUserPasswordProp(userDetail, t);
  };

  /**
   * Clears a user's two-factor enrolment so they can re-register a device
   * (Figma row menu, node 12385:163422). Same action the Partner card uses.
   * @param {string} id - User id.
   * @param {string} email - User email.
   * @returns {void}
   */
  const recoverMfa = async (id: string | undefined, email: string | undefined) => {
    const res = await dispatch(recoverUsersMFA({ email, userId: id }, t));
    if (res) getSupplierUserProp({ supplierId });
  };

  /**
   * Opens the set-password dialog for one user.
   * @param {object} user - The user record.
   * @returns {void}
   */
  const toggleChangePasswordModel = (user?: SupplierUserRow) => {
    setPasswordUser(user ?? {});
    setShowChangePassModel((previous) => !previous);
  };

  const onSortColumn = (propertyName: string) => {
    setCount(1);
    if (sortTable.sortOrder === '' || sortTable.sortOrder === 'Desc') {
      const sortObj = {
        sortOrder: 'Asc',
        sortPropertyName: propertyName,
        supplierId,
        searchText: state.searchText,
      };
      setSortTable(sortObj);
    } else {
      const sortObj = {
        sortOrder: 'Desc',
        sortPropertyName: propertyName,
        supplierId,
        searchText: state.searchText,
      };
      setSortTable(sortObj);
    }
  };

  const handleSortTable = async () => {
    await getSupplierUserProp(sortTable);
  };

  useEffect(() => {
    if (count > 0) handleSortTable();
  }, [sortTable, count]);

  const handleMultipleDelete = async () => {
    setisMultiDelete(true);
    setShowConfirmationPopup(!showConfirmationPopup);
  };

  const handleSearch = async (e: { target: { value: string } }) => {
    const targetValue = e.target.value;

    setState((previous) => ({
      ...previous,
      searchText: targetValue,
      searchLoaded: true,
    }));
  };

  const searchSetState = () => {
    setState((previous) => ({
      ...previous,
      loading: false,
    }));
    setIsLoader(false);
  };
  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (state.searchLoaded) {
        setState((previous) => ({
          ...previous,
          loading: true,
        }));
        if (allUsers.length) {
          const params = {
            searchText: state.searchText,
            supplierId,
          };
          setIsLoader(true);
          await getSupplierUserProp(params);
          searchSetState();
        } else {
          const params = {
            supplierId,
          };
          setIsLoader(true);
          await getSupplierUserProp(params);
          searchSetState();
        }
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [state.searchText]);

  useEffect(() => {
    const brandIds = (brands ?? []).map((brand) => brand?.value).filter((brandId) => brandId !== undefined && brandId !== '');
    if (brandIds.length === 0) return;
    dispatch(getMultiSubBrandDetails({ loggedInUserId, isActive: true, brandId: brandIds }));
  }, [brands, loggedInUserId]);

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <h4 className="title">{t('SUPPLIER_USERS.PAGE_TITLE')}</h4>
        </div>
        <div className="action-icons-container">
          <NewSearch
            className="bombiix-search"
            value={state?.searchText ?? ''}
            onChange={(value) => handleSearch({ target: { value } })}
            placeholder={t('SUPPLIER_OVERVIEW.SEARCH_USER')}
            width={200}
          />
          <NewBackButton onBack={() => history.push('/suppliers')} className="ml-8" />
        </div>
        <Floaty position="fixed">
          {CostingAddEditAccess && <FloatyButton icon={AddIcon} label={t('USER_LIBRARY.ADD_USER')} onClick={startAddRow} />}
          {(CostingAddEditAccess || CostingDeleteAccess) && (
            <FloatyGroup disabled={!selectedIdArray.length}>
              {CostingAddEditAccess && <FloatyButton icon={SettingsIcon} label={t('USER_TABLE.GLOBAL_ASSIGNMENT')} onClick={openGlobalAssignment} />}
              {CostingDeleteAccess && (
                <FloatyButton
                  icon={DeleteIcon}
                  variant="red"
                  label={t('DEVLOPMENT_ORDER.TESTING.PRODUCT_TESTING.DELETE')}
                  onClick={() => handleMultipleDelete()}
                />
              )}
            </FloatyGroup>
          )}
        </Floaty>
      </div>

      <SupplierTabNav />

      <div className="container-fluid py-4">
        <Row className="supplier-container">
          <Col lg="12">
            {isLoader ? (
              <Loader />
            ) : (
              <UserTable
                handleSelectAll={handleSelectAll}
                allUsers={allUsers}
                assignmentsByUser={assignmentsByUser}
                brandOptions={brands}
                subBrandOptions={subBrandOptions}
                category1Options={categoryType1}
                category2Options={categoryType2}
                draftRow={draftRow}
                editingUserId={editingUserId}
                onDraftChange={changeDraftField}
                onSaveRow={saveRowEdit}
                onCancelRow={cancelRowEdit}
                onStartEdit={startEditRow}
                onResetMfa={recoverMfa}
                onOpenSetPassword={toggleChangePasswordModel}
                onSelectCheckBox={onSelectCheckBox}
                onSortColumn={onSortColumn}
                isSelectAll={isSelectAll}
                selectedIdArray={selectedIdArray}
                onDelete={onDelete}
                onEdit={handleAddEditOpenClose}
                onEditStatus={handleUserStatusUpdate}
                sortTable={sortTable}
                onSetPassword={onSetPassword}
                CostingAddEditAccess={CostingAddEditAccess}
                CostingDeleteAccess={CostingDeleteAccess}
              />
            )}
          </Col>
        </Row>
      </div>

      {showConfirmationPopup && (
        <BombiixModal
          show={showConfirmationPopup}
          size="sm"
          title={t('SUPPLIER.SUPPLIER_USER.TITLE')}
          onClose={closeConfirmationsPopup}
          onSave={() => deleteSupplierConfirmed()}
          saveLabel={t('COMMON_LABEL.DELETE')}
          saveVariant="red"
          saveLoading={confirmLoader}
        >
          <div className="bombiix-modal__confirm-body">
            <p className="mb-0 text-center">{t('SUPPLIER.SUPPLIER_USER.DELETE_MESSAGE')}</p>
          </div>
        </BombiixModal>
      )}
      {isGlobalAssignment && (
        <GlobalAssignmentModal
          show={isGlobalAssignment}
          draft={globalDraft}
          selectedCount={selectedIdArray.length}
          brandOptions={brands}
          subBrandOptions={subBrandOptions}
          category1Options={categoryType1}
          category2Options={categoryType2}
          onChange={changeGlobalField}
          onSave={saveGlobalAssignment}
          saveDisabled={globalTouchedFields.length === 0}
          onClose={() => {
            setIsGlobalAssignment(false);
            setGlobalDraft(null);
            setGlobalTouchedFields([]);
          }}
        />
      )}
      {showChangePassModel && (
        <SetNewPassword
          title={t('COMPONENT_SUPPLIER_LISTING.SET_NEW_PASSWORD')}
          user={passwordUser}
          show={showChangePassModel}
          toggle={toggleChangePasswordModel}
        />
      )}
    </>
  );
}

/**
 * Maps the supplier slice this tab reads.
 * @param {SuppliersUsersStoreState} state - Root store state.
 * @returns {StateProps} The mapped props.
 */
const mapStateToProps = ({ SuppliersDetails, UserDetails }: SuppliersUsersStoreState): StateProps => {
  const { usersList, brands, categoryType1, categoryType2 } = SuppliersDetails;
  const { userInfo } = UserDetails;
  return {
    usersList,
    userInfo,
    brands,
    categoryType1,
    categoryType2,
  };
};

const mapStateToDispatch = {
  deleteUser,
  deleteMultiUser,
  getSupplierUser,
  updateUserStatus,
  fetchRightsAssignmentAction,
  fetchAllBrandAction,
  fetchCategoryAction,
  fetchCategory2Action,
  setUserPassword,
  clearUserReducer,
  addSupplierUser,
  editSupplierUser,
  addUserRightsAssignmentAction,
} as unknown as DispatchProps;

export default connect<StateProps, DispatchProps, OwnProps, SuppliersUsersStoreState>(mapStateToProps, mapStateToDispatch)(SuppliersUsers);
